import service from '@/router/axios'

// 删除
export const removeFinance = (params) => {
  return service({
    url: '/reportFinance/delete/finance',
    method: 'delete',
    params
  })
}

// 新增
export const addFinance = (data) => {
  return service({
    url: '/reportFinance/add/finance',
    method: 'post',
    data
  })
}

// 编辑
export const updateFinance = (data) => {
  return service({
    url: '/reportFinance/update/finance',
    method: 'put',
    data
  })
}

